(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* ==========================================================
   LX Header — behaviour
   sticky / hide-on-scroll, mega menu (hover or click, touch,
   keyboard), mobile drawer, search panel + product suggestions,
   cart count sync with Dawn's cart notification / drawer,
   theme-editor block selection.
   ========================================================== */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 140;

  function LxHeader(root) {
    this.root = root;
    this.section = root.closest('.shopify-section') || root.parentElement;
    this.bar = root.querySelector('[data-lx-bar]');
    this.announce = root.querySelector('[data-lx-announce]');
    this.drawer = root.querySelector('[data-lx-drawer]');
    this.search = root.querySelector('[data-lx-search]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-lx-item]'));
    this.sticky = root.getAttribute('data-sticky') || 'none';
    this.trigger = root.getAttribute('data-trigger') || 'hover';
    this.lastY = window.pageYOffset;
    this.openItem = null;
    this.editorLock = false;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onKey = this.onKey.bind(this);
    this.onDocClick = this.onDocClick.bind(this);

    this.initSticky();
    this.initMega();
    this.initDrawer();
    this.initSearch();
    this.initCart();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('click', this.onDocClick);
  }

  LxHeader.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('click', this.onDocClick);
    if (this.cartObserver) this.cartObserver.disconnect();
    if (this.unsubscribeCart) this.unsubscribeCart();
    document.body.style.overflow = '';
  };

  /* ---------------- Sticky ---------------- */
  LxHeader.prototype.initSticky = function () {
    if (this.sticky !== 'none' && this.section) this.section.classList.add('lx-sticky');
    this.measure();
  };

  LxHeader.prototype.isOver = function () {
    // true when the menu items + icons need more room than their side of the header has
    var over = false;
    this.bar.querySelectorAll('.lx-header__left, .lx-header__right').forEach(function (group) {
      var gap = parseFloat(getComputedStyle(group).columnGap) || 0;
      var need = 0, n = 0;
      Array.prototype.forEach.call(group.children, function (el) {
        if (el.offsetParent === null) return;
        var navs = el.querySelectorAll('.lx-nav');
        if (navs.length) {
          navs.forEach(function (nav) {
            var ng = parseFloat(getComputedStyle(nav).columnGap) || 0;
            var items = nav.children;
            for (var i = 0; i < items.length; i++) need += items[i].offsetWidth + (i ? ng : 0);
            need += parseFloat(getComputedStyle(nav).marginRight) || 0;
          });
        } else {
          need += el.offsetWidth;
        }
        n++;
      });
      need += gap * Math.max(0, n - 1);
      if (need > group.clientWidth + 1) over = true;
    });
    return over;
  };

  LxHeader.prototype.fits = function () {
    // Keep the full desktop menu visible. If it doesn't fit beside the logo:
    //  'shrink' (default) - scale menu text + spacing down step by step (never hides the menu)
    //  'drawer'           - switch to the menu button
    //  'none'             - do nothing
    var root = this.root;
    var mode = root.getAttribute('data-overflow') || 'shrink';
    root.classList.remove('lx-hdr--compact');
    ['--lx-nav-size', '--lx-nav-gap', '--lx-icon-gap'].forEach(function (v) { root.style.removeProperty(v); });
    if (!DESKTOP.matches || !this.bar || mode === 'none' || !this.isOver()) return;

    if (mode === 'drawer') { root.classList.add('lx-hdr--compact'); return; }

    var cs = getComputedStyle(root);
    var base = {
      size: parseFloat(cs.getPropertyValue('--lx-nav-size')) || 16,
      gap: parseFloat(cs.getPropertyValue('--lx-nav-gap')) || 28,
      icon: parseFloat(cs.getPropertyValue('--lx-icon-gap')) || 26
    };
    var minSize = parseFloat(root.getAttribute('data-min-size')) || 12;
    // Tighten the spacing between items first; only shrink the text if that isn't enough
    for (var g = 0.9; g >= 0.5; g -= 0.1) {
      root.style.setProperty('--lx-nav-gap', Math.max(14, base.gap * g).toFixed(1) + 'px');
      if (!this.isOver()) return;
    }
    for (var scale = 0.95; scale >= 0.5; scale -= 0.05) {
      var size = Math.max(minSize, base.size * scale);
      root.style.setProperty('--lx-nav-size', size.toFixed(1) + 'px');
      root.style.setProperty('--lx-nav-gap', Math.max(10, Math.min(14, base.gap * scale)).toFixed(1) + 'px');
      root.style.setProperty('--lx-icon-gap', Math.max(12, base.icon * scale).toFixed(1) + 'px');
      if (!this.isOver()) return;
    }
  };

  LxHeader.prototype.measure = function () {
    this.fits();
    var annH = this.announce ? this.announce.offsetHeight : 0;
    var barH = this.bar ? this.bar.offsetHeight : 0;
    var s = this.section || this.root;
    s.style.setProperty('--lx-ann-h-live', annH + 'px');
    s.style.setProperty('--lx-hdr-total', annH + barH + 'px');
    document.documentElement.style.setProperty('--header-height', barH + 'px');
    this.updateBottom();
  };

  LxHeader.prototype.updateBottom = function () {
    if (!this.bar) return;
    var bottom = Math.max(0, Math.round(this.bar.getBoundingClientRect().bottom));
    this.root.style.setProperty('--lx-hdr-bottom', bottom + 'px');
  };

  LxHeader.prototype.onScroll = function () {
    var self = this;
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(function () {
      self.ticking = false;
      var y = window.pageYOffset;
      var total = (self.announce ? self.announce.offsetHeight : 0) + (self.bar ? self.bar.offsetHeight : 0);

      if (self.sticky === 'on-scroll-up' && self.section) {
        var busy = self.openItem || (self.search && self.search.classList.contains('is-open')) || (self.drawer && self.drawer.classList.contains('is-open'));
        if (y > self.lastY && y > total && !busy) {
          self.section.classList.add('lx-is-hidden');
          self.closeAll();
        } else if (y < self.lastY || y <= total) {
          self.section.classList.remove('lx-is-hidden');
        }
      }
      self.section && self.section.classList.toggle('lx-scrolled', y > total);
      self.lastY = y;
      self.updateBottom();
    });
  };

  LxHeader.prototype.onResize = function () {
    this.measure();
    var compact = this.root.classList.contains('lx-hdr--compact');
    if (!DESKTOP.matches || compact) this.closeAll();
    else if (this.drawer && this.drawer.classList.contains('is-open')) this.closeDrawer();
  };

  /* ---------------- Mega / dropdown ---------------- */
  LxHeader.prototype.initMega = function () {
    var self = this;
    this.items.forEach(function (li) {
      var link = li.querySelector('.lx-nav__link');

      li.addEventListener('mouseenter', function () {
        if (self.trigger !== 'hover' || !DESKTOP.matches || self.root.classList.contains('lx-hdr--compact')) return;
        clearTimeout(li._lxClose);
        li._lxOpen = setTimeout(function () { self.open(li); }, OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () {
        if (self.trigger !== 'hover' || self.editorLock) return;
        clearTimeout(li._lxOpen);
        li._lxClose = setTimeout(function () { self.close(li); }, CLOSE_DELAY);
      });

      // Touch (hover mode) and click mode: first tap opens, second follows the link.
      link.addEventListener('pointerdown', function (e) { li._lxPointer = e.pointerType; });
      link.addEventListener('click', function (e) {
        var touch = li._lxPointer === 'touch' || li._lxPointer === 'pen';
        if (self.trigger === 'click' || touch) {
          if (!li.classList.contains('is-open')) {
            e.preventDefault();
            self.open(li);
          }
        }
      });

      // Keyboard: arrow down / Enter-space when link is "#"
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          self.open(li);
          var first = li.querySelector('.lx-mega a, .lx-dd a');
          if (first) first.focus();
        }
      });

      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) self.close(li);
      });
    });
  };

  LxHeader.prototype.open = function (li) {
    if (this.openItem && this.openItem !== li) this.close(this.openItem, true);
    li.classList.add('is-open');
    var link = li.querySelector('.lx-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
    this.openItem = li;
    if (li.classList.contains('lx-has-mega')) this.root.classList.add('has-open-mega');
    this.updateBottom();
    if (this.search) this.closeSearch();
  };

  LxHeader.prototype.close = function (li, keepDim) {
    if (!li) return;
    li.classList.remove('is-open');
    var link = li.querySelector('.lx-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (this.openItem === li) this.openItem = null;
    if (!keepDim) this.root.classList.remove('has-open-mega');
  };

  LxHeader.prototype.closeAll = function () {
    var self = this;
    this.items.forEach(function (li) { self.close(li); });
  };

  LxHeader.prototype.onDocClick = function (e) {
    if (this.openItem && !this.openItem.contains(e.target)) this.close(this.openItem);
    if (this.search && this.search.classList.contains('is-open') &&
        !this.search.contains(e.target) && !e.target.closest('[data-lx-search-open]')) this.closeSearch();
  };

  LxHeader.prototype.onKey = function (e) {
    if (e.key !== 'Escape') return;
    if (this.drawer && this.drawer.classList.contains('is-open')) return this.closeDrawer();
    if (this.search && this.search.classList.contains('is-open')) return this.closeSearch(true);
    if (this.openItem) {
      var link = this.openItem.querySelector('.lx-nav__link');
      this.close(this.openItem);
      if (link) link.focus();
    }
  };

  /* ---------------- Drawer ---------------- */
  LxHeader.prototype.initDrawer = function () {
    var self = this;
    if (!this.drawer) return;
    this.burger = this.root.querySelector('[data-lx-drawer-open]');
    if (this.burger) this.burger.addEventListener('click', function () { self.openDrawer(); });
    this.drawer.querySelectorAll('[data-lx-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeDrawer(); });
    });
    // Accordion: keep one top-level panel open at a time
    var tops = this.drawer.querySelectorAll('.lx-mnav > li > details');
    tops.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        tops.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    // Focus trap
    this.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = self.drawer.querySelectorAll('a[href], button, summary, select, input');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };

  LxHeader.prototype.openDrawer = function () {
    this.closeSearch();
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var close = this.drawer.querySelector('.lx-drawer__close');
    if (close) setTimeout(function () { close.focus(); }, 50);
  };

  LxHeader.prototype.closeDrawer = function () {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.burger) { this.burger.setAttribute('aria-expanded', 'false'); if (!DESKTOP.matches) this.burger.focus(); }
    document.body.style.overflow = '';
  };

  /* ---------------- Search ---------------- */
  LxHeader.prototype.initSearch = function () {
    var self = this;
    if (!this.search) return;
    this.searchBtn = this.root.querySelector('[data-lx-search-open]');
    this.input = this.search.querySelector('[data-lx-search-input]');
    this.results = this.search.querySelector('[data-lx-search-results]');
    this.predictive = this.root.getAttribute('data-predictive') === 'true';
    this.suggestUrl = this.root.getAttribute('data-suggest-url') || '/search/suggest';
    this.searchUrl = this.root.getAttribute('data-search-url') || '/search';

    if (this.searchBtn) this.searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      self.search.classList.contains('is-open') ? self.closeSearch() : self.openSearch();
    });
    var closeBtn = this.search.querySelector('[data-lx-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.closeSearch(true); });

    if (this.predictive && this.input) {
      var timer;
      this.input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = self.input.value.trim();
        if (q.length < 2) { self.results.innerHTML = ''; return; }
        timer = setTimeout(function () { self.suggest(q); }, 250);
      });
    }
  };

  LxHeader.prototype.openSearch = function () {
    this.closeAll();
    this.search.classList.add('is-open');
    if (this.searchBtn) this.searchBtn.setAttribute('aria-expanded', 'true');
    var input = this.input;
    setTimeout(function () { input && input.focus(); }, 60);
  };

  LxHeader.prototype.closeSearch = function (returnFocus) {
    if (!this.search) return;
    this.search.classList.remove('is-open');
    if (this.searchBtn) {
      this.searchBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.searchBtn.focus();
    }
  };

  LxHeader.prototype.formatMoney = function (value) {
    var num = parseFloat(value);
    if (isNaN(num)) return value || '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(num);
    } catch (e) { return num.toFixed(2); }
  };

  LxHeader.prototype.suggest = function (q) {
    var self = this;
    var url = this.suggestUrl + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
    if (this.abort) this.abort.abort();
    this.abort = window.AbortController ? new AbortController() : null;
    fetch(url, this.abort ? { signal: this.abort.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
        var all = self.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        if (!products.length) {
          self.results.innerHTML = '<p class="lx-search__empty">No products found for “' + esc(q) + '”.</p>' +
            '<a class="lx-search__all" href="' + all + '">Search all results</a>';
          return;
        }
        var html = '<div class="lx-search__grid">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          html += '<a class="lx-search__item" href="' + esc(p.url) + '">' +
            '<span class="lx-search__item-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
            esc(p.title) + '<span class="lx-search__item-price">' + esc(self.formatMoney(p.price)) + '</span></a>';
        });
        html += '</div><a class="lx-search__all" href="' + all + '">View all results</a>';
        self.results.innerHTML = html;
      })
      .catch(function () {});
  };

  /* ---------------- Cart count ---------------- */
  LxHeader.prototype.initCart = function () {
    var self = this;
    this.cart = document.getElementById('cart-icon-bubble');
    if (!this.cart || !this.root.contains(this.cart)) return;
    this.cartTemplate = this.cart.innerHTML;

    // Dawn replaces #cart-icon-bubble's markup after add-to-cart; put ours back with the new count.
    this.cartObserver = new MutationObserver(function () {
      if (self.cart.querySelector('[data-lx-cart-count]')) return;
      var bubble = self.cart.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      var hasBubble = self.cart.querySelector('.cart-count-bubble');
      var count = bubble ? parseInt(bubble.textContent, 10) : (hasBubble ? 100 : 0);
      self.cart.innerHTML = self.cartTemplate;
      self.setCount(count);
    });
    this.cartObserver.observe(this.cart, { childList: true });

    // Dawn pub/sub (cart drawer + quantity changes)
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      this.unsubscribeCart = window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self.refreshCount(); });
    }
    // Custom add-to-cart code (diamond pages, cart sync) fires these instead
    ['cart:updated', 'cart:added', 'cart:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () { self.refreshCount(); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.refreshCount(); });
  };

  LxHeader.prototype.setCount = function (count) {
    var el = this.cart.querySelector('[data-lx-cart-count]');
    if (!el) return;
    el.textContent = count > 99 ? '99+' : count;
    el.hidden = !count;
  };

  LxHeader.prototype.refreshCount = function () {
    var self = this;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { self.setCount(c.item_count); })
      .catch(function () {});
  };

  /* ---------------- Theme editor ---------------- */
  LxHeader.prototype.selectBlock = function (id) {
    var desk = this.root.querySelector('.lx-mega[data-lx-block="' + id + '"]');
    if (DESKTOP.matches && desk && !this.root.classList.contains('lx-hdr--compact')) {
      this.editorLock = true;
      this.open(desk.closest('li'));
      return;
    }
    var mob = this.root.querySelector('details[data-lx-block="' + id + '"]');
    if (mob) { this.openDrawer(); mob.open = true; }
  };

  LxHeader.prototype.deselectBlock = function () {
    this.editorLock = false;
    this.closeAll();
  };

  /* ---------------- Boot ---------------- */
  var instances = new Map();

  function init(scope) {
    (scope || document).querySelectorAll('[data-lx-header]').forEach(function (el) {
      if (instances.has(el)) return;
      instances.set(el, new LxHeader(el));
    });
  }

  function findInstance(target) {
    var found = null;
    instances.forEach(function (inst, el) { if (target && target.contains(el)) found = inst; });
    return found;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  window.addEventListener('load', function () { instances.forEach(function (i) { i.measure(); }); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { instances.forEach(function (i) { i.measure(); }); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (inst, el) {
      if (e.target.contains(el)) { inst.destroy(); instances.delete(el); }
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var inst = findInstance(e.target.closest('.shopify-section') || e.target);
    if (inst) inst.selectBlock(e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var inst = findInstance(e.target.closest('.shopify-section') || e.target);
    if (inst) inst.deselectBlock();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
